import gql from 'graphql-tag';

const FIND_FRICTIONLESS_TAG = gql`
  query findFrictionlessTag($data: FindFrictionlessTagInput!) {
    findFrictionlessTag(data: $data) {
      name
      path
      size
      content
    }
  }
`;

export default FIND_FRICTIONLESS_TAG;
